import { render } from "./PermissionErrorPage.vue?vue&type=template&id=31478f89&ts=true"
import script from "./PermissionErrorPage.vue?vue&type=script&lang=ts"
export * from "./PermissionErrorPage.vue?vue&type=script&lang=ts"

import exportComponent from "/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
